export default function objectMap<T,V>(
    record:Record<string, T>,
    callb: (object: T, key?: string) => V
): Array<V> {
    return Object.keys(record).map(key => {
        const value = record[key]
        return callb(value)
    })
}